module.exports = __webpack_public_path__ + "static/healthcare-furniture-641f5f214d7c1b6eca028c60368bc22d.jpg";